module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal in",
    attrs: {
      "id": "nodeModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('NodesList', {
    attrs: {
      "nodes": _vm.nodes
    }
  })], 1)])])]), _vm._v(" "), (_vm.isTab) ? _c('div', {
    attrs: {
      "id": "node-header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "nav nav-pills node-filter"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.current[2] === undefined
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/topics"
    }
  }, [_vm._v("默认")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.current[2] === 'popular'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/topics/popular"
    }
  }, [_vm._v("优质帖子")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.current[2] === 'no_reply'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/topics/no_reply"
    }
  }, [_vm._v("无人问津")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.current[2] === 'last'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/topics/last"
    }
  }, [_vm._v("最新发布")])], 1)])])]) : _c('div', {
    staticClass: "node-panel panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "node-title"
  }, [_vm._v(_vm._s(_vm.node ? _vm.node.name : '')), _c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "rgb(153, 153, 153)",
      "margin-left": "10px"
    }
  }, [_vm._v("共有" + _vm._s(_vm.node ? _vm.node.topics_count : '') + "个讨论主题")])]), _vm._v(" "), _c('div', {
    staticClass: "node-summry"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.summary)
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('strong', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("选择话题节点")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('button', {
    staticClass: "node-button btn btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#nodeModal"
    }
  }, [_vm._v("所有节点"), _c('span', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b93c3cd!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/TabHeader.vue
// module id = 278
// module chunks = 6